var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMemoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 24,
    viewBox: "0 0 72 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94 4.734h1.983l4.979 7.45 4.973-7.454h1.988v14.523h-2.08V8.448l-4.734 6.94h-.343l-4.729-6.94V19.23H1.94V4.734zm19.395 0H31.97v1.94h-8.554v4.307h7.66v1.94h-7.66v4.42h8.657v1.94H21.335V4.733zm15.426 0h1.998l4.974 7.457 4.979-7.457h1.983v14.523h-2.08V8.452l-4.732 6.94h-.343l-4.727-6.938v10.784h-2.041l-.01-14.504zm33.31 7.264c0 4.144-3.314 7.502-7.403 7.502-4.09 0-7.404-3.363-7.404-7.502 0-4.14 3.314-7.498 7.404-7.498 4.089 0 7.403 3.354 7.403 7.498zm-7.403-5.545c-2.914 0-5.275 2.482-5.275 5.545 0 3.062 2.356 5.544 5.275 5.544 2.918 0 5.276-2.482 5.276-5.544 0-3.063-2.363-5.545-5.276-5.545z",
    fill: "#426AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMemoSmall);
export default __webpack_public_path__ + "static/media/logo-memo-small.89a08567e87d18313975ad99f347e307.svg";
export { ForwardRef as ReactComponent };